export const ADD_FORM_PROPERTIES = 'ADD_FORM_PROPERTIES';
export const ADD_FORM_DRAFT_PROPERTIES = 'ADD_FORM_DRAFT_PROPERTIES';
export const ADD_FORM_COMPLETE = 'ADD_FORM_COMPLETE';
export const ADD_FORM_SUBMISSION_FAILED = 'ADD_FORM_SUBMISSION_FAILED'

export const addFormProperties = (text) => ({
    type: ADD_FORM_PROPERTIES,
    payload: text
});

export const addFormDraftProperties = (text) => ({
    type: ADD_FORM_DRAFT_PROPERTIES,
    payload: text
});

export const addFormComplete = () => ({
    type: ADD_FORM_COMPLETE,
});

export const addFormSubmissionFailed = () => ({
    type: ADD_FORM_SUBMISSION_FAILED,
});